export const DEMOTE_MODERATOR_REQUEST = 'user/DEMOTE_MODERATOR_REQUEST';
export const DEMOTE_MODERATOR_SUCCESS = 'user/DEMOTE_MODERATOR_SUCCESS';
export const DEMOTE_MODERATOR_FAILURE = 'user/DEMOTE_MODERATOR_FAILURE';

export const demoteModeratorRequest = () => ({ type: DEMOTE_MODERATOR_REQUEST });
export const demoteModeratorSuccess = payload => ({ type: DEMOTE_MODERATOR_SUCCESS, payload });
export const demoteModeratorFailure = () => ({ type: DEMOTE_MODERATOR_FAILURE });

export const demoteModerator = userId => (dispatch, getState, { request }) => {
  dispatch(demoteModeratorRequest());
  const promise = request.delete(`/_api/users/${userId}/permissions`);
  return promise
    .then(user => dispatch(demoteModeratorSuccess(user)))
    .catch(() => dispatch(demoteModeratorFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/demote-moderator.js